/**
 * Market model
 */
export default class MarketTabModel {
  /**
   * Class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Tab ID
     * @type {number}
     */
    this.id = data[0];
    /**
     * Tab name
     * @type {string}
     */
    this.name = data[1];
  }
}
